import { Link } from 'react-router';
import { Mail, Twitter, Linkedin } from 'lucide-react';
import Logo from "@/components/common/Logo";

const Footer = () => {
  return (
    <footer className="glass-card border-t border-glass-border mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Logo className="h-8 w-auto" />
              <span className="sr-only">Arcitext</span>
            </div>
            <p className="text-muted-foreground text-sm">
              AI-assisted writing tools that help you maintain your authentic voice while scaling your content creation.
            </p>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Mail className="w-4 h-4" />
              <a href="mailto:hello@arcitext.com" className="text-sm hover:text-primary transition-colors">
                hello@arcitext.com
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">AI-Assisted Copywriting</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/for-creators" className="hover:text-primary transition-colors">
                  For Creators
                </Link>
              </li>
              <li>
                <Link to="/for-professionals" className="hover:text-primary transition-colors">
                  For Professionals
                </Link>
              </li>
              <li>
                <Link to="/features" className="hover:text-primary transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-primary transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Social */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Find Arcitext Here</h3>
            <div className="flex gap-4 mb-6">
              <a href="https://www.producthunt.com/products/arcitext?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-arcitext&#0045;com" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1030158&theme=dark&t=1762332226690" alt="Arcitext&#0046;com - Write&#0032;in&#0032;your&#0032;voice&#0046;&#0032;Perfect&#0032;it&#0032;with&#0032;AI&#0046; | Product Hunt" className="w-[250px] h-[54px]" /></a>
            </div>
            <div className="flex gap-4 mb-6">
              <a
                href="https://x.com/arcitexthq"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="X (Twitter)"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/arcitext/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-muted-foreground">
              Arcitext is a{' '}
              <a
                href="https://fjordkit.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors font-medium"
              >
                FjordKit Digital
              </a>
              {' '}product.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} Arcitext. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-primary transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
